import React from 'react';
import PropTypes from 'prop-types';
import {YoutubeVideoConstants} from '../../adapters/helpers/Constants';

const DEFAULT_ASPECT_RATIO = 16/9;

export default function YoutubeVideo({document}) {
    const videoId = document?.fields?.videoId || document?.videoId ;
    const aspectRatio = document?.fields?.aspectRatio || DEFAULT_ASPECT_RATIO;
    const classNames = document?.fields?.classNames || '';
    const videoTitle = document?.fields?.name || document?.name || YoutubeVideoConstants.defaultVideoTitle
    // Enhanced YouTube URL with accessibility parameters
    const accessibilityEnhancedUrl = `${YoutubeVideoConstants.url}${videoId}?modestbranding=1&rel=0&cc_load_policy=1&disablekb=0&fs=1&hl=en`
    
    // Dynamic accessibility labels using constants
    const ariaLabel = YoutubeVideoConstants.ariaLabelTemplate(videoTitle)
    const iframeTitle = YoutubeVideoConstants.titleTemplate(videoTitle)

    return (<>
        {!!videoId &&
            <div className={classNames}>
                <div className="ob-youtube-video-block" role="application" aria-label={ariaLabel} style={{paddingBottom: (100/ aspectRatio).toFixed(3) + YoutubeVideoConstants.percent}}>
                <iframe 
                        loading='lazy' 
                        aria-label={ariaLabel}
                        title={iframeTitle}
                        src={accessibilityEnhancedUrl}
                        frameBorder="0"
                        allowFullScreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                    ></iframe>
                </div>
            </div>
        }
    </>)
}

YoutubeVideo.propTypes = {
    document: PropTypes.object,
}